import AuthPage, { AuthMode } from './AuthPage'

/**
 * SignUpPage Component
 *
 * Renders the sign-up variant of the shared AuthPage.
 * See AuthPage for layout and appearance config.
 */
const SignUpPage = () => <AuthPage mode={AuthMode.SIGN_UP} />

export default SignUpPage
